import {
  ApplicationConfig,
  ErrorHandler,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withRouterConfig } from '@angular/router';

import {
  provideTranslateLoader,
  provideTranslateService,
} from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { GlobalErrorHandler, provideMsalAuth, authErrorInterceptor } from '#core';
import { LanguageLoader } from '#locale';
import { routes } from './app.routes';
import { DialogService } from 'primeng/dynamicdialog';
import { LoadingIndicatorService } from '#services';
import { primetheme } from '../styles/primetheme';
import { appInitializer } from './app-initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([authErrorInterceptor])),
    provideAppInitializer(appInitializer),
    provideMsalAuth(),
    provideTranslateService({
      loader: provideTranslateLoader(LanguageLoader),
      fallbackLang: 'en',
      lang: 'en',
    }),

    providePrimeNG({
      theme: {
        preset: primetheme,
        options: {
          darkModeSelector: false,
        },
      },
      ripple: true,
    }),
    MessageService,
    ConfirmationService,
    provideAnimationsAsync(),
    DialogService,
    LoadingIndicatorService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
};
